export class Measurement{
    constructor(magnitude, axis) {
        this.magnitude = magnitude;
        this.axis = axis;
    }
}